export const APP_FILE_G4SIGN_DOCUMENTS_ROUTE = "/g4sign/documents";
export const APP_FILE_MANAGE_G4SIGN_DOCUMENTS_ROUTE = "/g4sign/documents/manage";
export const APP_FILE_MANAGE_G4SIGN_DOCUMENTS_ID_ROUTE = "/g4sign/documents/manage/:documentCode";